import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-offcanvas-trigger',
  standalone: false,
  templateUrl: './offcanvas-trigger.component.html',
  styleUrl: './offcanvas-trigger.component.scss',
})
export class OffcanvasTriggerComponent implements ICellRendererAngularComp {
  data: any;
  componentParent: any;

  agInit(params: ICellRendererParams): void {
    this.data = params.data;

    this.componentParent = params.context.componentParent;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  protected onClick() {
    try {
      this.componentParent.openOffcanvas(this.data);
    } catch (err) {
      console.error(err);
    }
  }
}
